import { render, staticRenderFns } from "./addservicegroup.vue?vue&type=template&id=4eb19fb0&scoped=true&"
import script from "./addservicegroup.vue?vue&type=script&lang=js&"
export * from "./addservicegroup.vue?vue&type=script&lang=js&"
import style0 from "./addservicegroup.vue?vue&type=style&index=0&id=4eb19fb0&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb19fb0",
  null
  
)

export default component.exports